import { useTheme } from '../contexts/ThemeContext'
import { MONDRIAN_MODULES } from '../config/themes'

export default function MondrianBg() {
  const { theme, module } = useTheme()
  if (theme !== 'mondrian') return null

  const m = MONDRIAN_MODULES[module] || MONDRIAN_MODULES.default

  return (
    <svg
      className="absolute inset-0 w-full h-full pointer-events-none"
      style={{ zIndex: 0, opacity: 0.08 }}
      viewBox="0 0 380 260"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: m.composition }}
    />
  )
}
